import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Divider, Skeleton, Typography } from '@mui/material';
import { HighchartBarChart } from '../../../shared';
import { CPC_H } from './constants';
import { customCategories } from '../../../../utility';
import PropTypes from 'prop-types';

const CPCChart = ({ chart_data,isLoading }) => {
    const { company } = useSelector((state) => state.company);
    const categories = chart_data.map(item=> item.month);
    const data = chart_data.map(item=> item.cost);
    const updatedCategories = useMemo(() => customCategories(categories), [categories]);

    const barChartOptions = useMemo(() => ({
        ...CPC_H,
        xAxis: {
            ...CPC_H.xAxis,
            categories: updatedCategories
        }
    }), [updatedCategories]);

    const [key, setKey] = useState(0);

    useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [company]);

    return (
        <Box className="web-metrics-graph-container">
            <Box className="padding-tb-24-rl-20">
                <Typography className="text-md-semi-bold gray-900">{'Cost Per 30 Second of Session Visit ($)'}</Typography>
            </Box>
            <Divider className="border-gray-200" />
            <Box className="padding-24px min-height-402px">
                { isLoading ? <Skeleton height={'400px'} variant='rectangular'/> :
                    <HighchartBarChart
                        chartOptions={barChartOptions}
                        key={key}
                        seriesData={data}
                        seriesName={'Cost'}
                    />
                }
            </Box>
        </Box>
    );
};

CPCChart.propTypes= { chart_data: PropTypes.array.isRequired, isLoading: PropTypes.bool.isRequired };

export default CPCChart;
